import React from 'react'

import Text from 'components_new/atoms/Text'

import DataHealthKpiCard from 'components_new/organisms/internal/DataHealth/KpiCard'

import { formatDayClock } from 'components_new/organisms/internal/DataRuns/utils'
import { formatRerunProgress } from 'components_new/organisms/internal/DataReruns/utils'
import { DataRerunSummary } from 'redux/selectors/internal/DataReruns'

export interface DataHealthRerunKpiCardProps {
  /** The rerun in progress, else the latest one, null when none exists. */
  rerun: DataRerunSummary | null
  onClick: () => void
}

/** The Körning tile on Översikt, linking to the Körningar tab. */
const DataHealthRerunKpiCard = (props: DataHealthRerunKpiCardProps) => {
  const { onClick, rerun } = props

  if (!rerun) {
    return (
      <DataHealthKpiCard
        label="Körning"
        onClick={onClick}
        sub="ingen körning ännu"
        value="–"
      />
    )
  }

  if (rerun.status === 'running') {
    return (
      <DataHealthKpiCard
        label="Körning"
        onClick={onClick}
        sub={formatRerunProgress(rerun)}
        value={
          <Text
            component="span"
            sx={{
              color: 'info.text',
              font: 'inherit',
              letterSpacing: 'inherit'
            }}
          >
            Pågår
          </Text>
        }
      />
    )
  }

  return (
    <DataHealthKpiCard
      label="Körning"
      onClick={onClick}
      sub={`${formatDayClock(rerun.started_at)} · ${rerun.customer_count} kunder`}
      value={rerun.status === 'cancelled' ? 'Avbruten' : 'Klar'}
    />
  )
}

DataHealthRerunKpiCard.displayName = 'DataHealthRerunKpiCard'
export default DataHealthRerunKpiCard
